import { motion } from "framer-motion";
import { TRENDING } from "@/data/news";

export const Sidebar = () => (
  <aside id="trending" data-testid="trending-sidebar" className="lg:sticky lg:top-24 space-y-8">
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
    >
      <div className="flex items-center justify-between border-b border-white/10 pb-4 mb-2">
        <h3 className="font-display text-3xl text-white tracking-wide">Trending Now</h3>
        <span className="font-mono-news text-[10px] text-zinc-500 uppercase tracking-widest">100% Liger</span>
      </div>
      <ol>
        {TRENDING.map((item, i) => (
          <li key={item.id}>
            <a
              href="#article"
              data-testid={`sidebar-article-${item.id}`}
              className="trend-item flex gap-5 border border-transparent border-b-white/5 px-3 py-5 -mx-3"
            >
              <span className="font-display text-3xl text-outline leading-none shrink-0 w-8">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span>
                <span className="block font-mono-news text-[10px] text-[#4ADE80] uppercase tracking-widest mb-1.5">
                  {item.tag}
                </span>
                <span className="trend-title block text-sm sm:text-base text-zinc-200 leading-snug">
                  {item.title}
                </span>
              </span>
            </a>
          </li>
        ))}
      </ol>
    </motion.div>

    <motion.div
      data-testid="sidebar-status-widget"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7, delay: 0.1 }}
      className="bg-[#121214] border border-white/10 p-6"
    >
      <div className="flex items-center gap-2 mb-4">
        <span className="live-dot" />
        <span className="font-mono-news text-xs text-red-400 uppercase tracking-widest">Liger Status Monitor</span>
      </div>
      <ul className="space-y-3 font-mono-news text-xs text-zinc-400 uppercase tracking-wider">
        <li className="flex justify-between border-b border-white/5 pb-3"><span>YouTube</span><span className="text-red-400">Offline</span></li>
        <li className="flex justify-between border-b border-white/5 pb-3"><span>Discord</span><span className="text-red-400">Invisible</span></li>
        <li className="flex justify-between border-b border-white/5 pb-3"><span>Minecraft SMP</span><span className="text-red-400">Never Joined</span></li>
        <li className="flex justify-between border-b border-white/5 pb-3"><span>Clash Royale</span><span className="text-[#4ADE80]">Suspiciously Active</span></li>
        <li className="flex justify-between"><span>Vibes</span><span className="text-[#4ADE80]">Immaculate</span></li>
      </ul>
    </motion.div>
  </aside>
);
